import { render, staticRenderFns } from "./member-income.vue?vue&type=template&id=2bd588a7&scoped=true"
import script from "./member-income.vue?vue&type=script&lang=js"
export * from "./member-income.vue?vue&type=script&lang=js"
import style0 from "./member-income.vue?vue&type=style&index=0&id=2bd588a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd588a7",
  null
  
)

export default component.exports